import React from "react";
import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Set } from "../../../../Request/index";
import CommonFrom from "../../../Common/Components/Form";

const SubmitUsers = () => {
  const [data, setData] = useState({});
  const { item_id } = useParams();
  const navigate = useNavigate();
  const submit = async data => {
    setData({ loading: true });
    await Set({ url: "/item/addmanager", data: { ...data, item_id } }).then(
      res => {
        if (res) {
          navigate(-1);
        }
        setData({ loading: false });
      }
    );
  };

  const input = [
    {
      label: "شماره موبایل",
      size: "col-md-6",
      classNames: "mt-2",
      placeholder: "",
      name: "mobile",
      type: "text",
      check: "/manager/check_user",
    },
    {
      label: "نام",
      size: "col-md-6",
      classNames: "mt-2 ",
      name: "fullname",
      type: "text",
    },
    {
      label: "کد ملی",
      size: "col-md-6",
      classNames: "mt-2",
      placeholder: "",
      name: "national_code",
      type: "text",
    },

    {
      label: "انتخاب جنسیت ",
      size: "col-md-6",
      classNames: "mt-2",
      placeholder: "",
      name: "gender",
      input: "select",
      options: [
        { id: "", name: "انتخاب کنید" },
        { id: "man", name: "مرد" },
        { id: "woman", name: "زن" },
      ],
    },
  ];
  return (
    <CommonFrom
      form={input}
      loading={data.loading}
      header="ثبت مدیر"
      btnName="ثبت اطلاعات کاربر"
      submit={submit}
    />
  );
};

export default SubmitUsers;
